import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "app/login/login.service";
import { LaudosPdfModel } from "./laudos-pdf.model";
import { LaudosPdfService } from "./laudos-pdf.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ClientesService } from "../clientes/clientes.service";
import { MercadoriasService } from "../mercadorias/mercadorias.service";
import { FichasService } from "../fichas/fichas.service";
import { TiposClientesService } from "../clientes/tipos-clientes.service";
import { UnidadesService } from "../unidades/unidades.service";
import { TerminaisService } from "../terminais/terminais.service";

declare let swal, $: any;

@Component({
  selector: 'app-laudos-pdf',
  templateUrl: './laudos-pdf.component.html'
})
export class LaudosPdfComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "mercadoria": "", "cliente": "", "terminal": "", "id_unidade": "", "numero": "", "ordem_campo": "data", "ordem_direcao": "d" };
  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  laudos: LaudosPdfModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };
  permissoesMenu = [];

  listStatusFichas = [];
  listMercadorias = [];
  listClientes = [];
  listTerminal = [];
  listUnidades = [];
  selecionarTodos: boolean = false;
  selecionados: any = {};
  processandoItem: any = {};
  carregandoAcoesEmMassa: boolean = false;
  idLaudoParaEnviarEmail: string;
  emailDestinatario: string = '';
  enviandoEmail: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    private laudosService: LaudosPdfService,
    private fichasService: FichasService,
    private clientesService: ClientesService,
    private mercadoriasService: MercadoriasService,
    private tiposClientesService: TiposClientesService,
    private unidadesService: UnidadesService,
    private terminaisService: TerminaisService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8) + '01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.loginService.getUserInfo().subscribe(data => {
      let permissoes = [];
      for (let i in data.privilegios) {
        if (data.privilegios[i].consultar || data.privilegios[i].editar) {
          permissoes.push(String(data.privilegios[i].id_acao));
        }
        if (data.privilegios[i].acao && data.privilegios[i].acao[0] && data.privilegios[i].acao[0].url == 'fichas') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
      this.permissoesMenu = permissoes;
    });

    this.formPesquisaAvancada = formBuilder.group({
      status_pesquisa: [],
      data_de: [],
      data_ate: [],
      mercadoria: [],
      cliente: [],
      terminal: [],
      id_unidade: [],
      numero: []
    });

    this.fichasService.getStatus()
      .subscribe(
        json => {
          this.listStatusFichas = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    // busca clientes por tipo
    this.tiposClientesService.get(["clientes"])
      .subscribe(
        json => {
          //this.ficha = json.Payload;


          for (let x in json.Payload) {
            switch (json.Payload[x].id_tipo) {
              case "1":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;

              case "2":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;

              case "6":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;
              default:
                break;
            }
          }

        },
        error => {
          this.func.showErro(error.json());
        });

    // busca terminais
    this.terminaisService.get()
      .subscribe(
        json => {
          this.listTerminal = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.mercadoriasService.get(null, null, ['id', 'nome_padrao'])
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    // busca unidades
    this.unidadesService.get(null, null, ['id_unidade', 'nome_tratamento'])
      .subscribe(json => {
        this.listUnidades = json.Payload;
      });
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = Object.assign(this.filtroPesquisa, filtroSalvo);
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }
    this.getPage(1);
  }

  setOrdem(campo: string) {
    if (this.filtroPesquisa.ordem_campo === campo) {
      this.filtroPesquisa.ordem_direcao = (this.filtroPesquisa.ordem_direcao === 'a') ? 'd' : 'a';
    } else {
      this.filtroPesquisa.ordem_campo = campo;
      this.filtroPesquisa.ordem_direcao = 'a';
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
  }

  delete(ficha) {
    let laudos = this.laudos;
    let laudosService = this.laudosService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarFicha') + ficha.id_laudo,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {

        if (self.global.debug == true) {
          console.log(laudos);
        }

        let index = laudos.indexOf(ficha);
        laudos.splice(index, 1);

        laudosService.apagar(ficha.id_laudo)
          .subscribe(res => {
            //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
            self.laudos = laudos;
          },
            err => {
              // Revert the view back to its original state
              laudos.splice(index, 0, ficha);
              self.laudos = laudos;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.filtroPesquisa.status_pesquisa != '') {
      filtros['id_status'] = this.filtroPesquisa.status_pesquisa;
    }

    if (this.filtroPesquisa.data_de && this.filtroPesquisa.data_ate) {
      filtros['data'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de) {
        filtros['data'] = 'ge:' + this.filtroPesquisa.data_de;
      }

      if (this.filtroPesquisa.data_ate) {
        filtros['data'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }

    if (this.filtroPesquisa.mercadoria != '') {
      filtros['id_mercadoria'] = this.filtroPesquisa.mercadoria;
    }

    if (this.filtroPesquisa.cliente != '') {
      filtros['id_cliente'] = this.filtroPesquisa.cliente;
    }

    if (this.filtroPesquisa.terminal != '') {
      filtros['id_terminal'] = this.filtroPesquisa.terminal;
    }

    if (this.filtroPesquisa.id_unidade != '') {
      filtros['id_unidade'] = this.filtroPesquisa.id_unidade;
    }

    if (this.filtroPesquisa.numero != '') {
      filtros['numero'] = "**:" + this.filtroPesquisa.numero;
    }


    let sort = {};
    let campoSort = this.filtroPesquisa.ordem_campo || 'data';
    let direcaoSort = this.filtroPesquisa.ordem_direcao || 'd';
    sort[campoSort] = direcaoSort;

    this.laudosService.getPaginacao(pagina, this.itensPorPagina, ['mercadoria', 'cliente', 'unidade', 'terminal', 'status'], filtros, null, sort)
      .subscribe(data => {
        this.laudos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.laudos);
        }
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  enviaParaCliente(id) {

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaEnviarFichaCliente'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.processandoItem[id] = true;
        self.laudosService.enviarLaudoParaCliente(id)
          .subscribe(res => {
              delete self.processandoItem[id];
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.notificadoComSucesso'), "success");
            },
            err => {
              delete self.processandoItem[id];
              self.func.showErro(err.json());
            });

      });

  }


  alteraStatus(id_laudo, id_status, notificar: boolean = true) {

    let laudosService = this.laudosService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaAlterarStatus'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true,
    },
      function () {
        self.processandoItem[id_laudo] = true;
        laudosService.setStatus(id_laudo, id_status, notificar)
          .subscribe(res => {
            delete self.processandoItem[id_laudo];
            swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");

            self.getPage(self.paginaAtual);
          },
            error => {
              delete self.processandoItem[id_laudo];
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");

              self.func.showErro(error.json());
            });

      });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    if (this.filtroPesquisa.data_de && !this.filtroPesquisa.data_ate) {
      this.filtroPesquisa.data_ate = new Date().toISOString().split('T')[0];
      this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "mercadoria": "", "cliente": "", "terminal": "", "id_unidade": "", "numero": "", "ordem_campo": "data", "ordem_direcao": "d" };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  marcarTodos(event) {
    this.selecionarTodos = event.target.checked;
    this.laudos.forEach(laudo => {
      this.selecionados[laudo.id_laudo] = this.selecionarTodos;
    });
  }

  marcarItem(laudo, event) {
    this.selecionados[laudo.id_laudo] = event.target.checked;

    // Se desmarcar um item, desmarca o "selecionar todos"
    if (!event.target.checked) {
      this.selecionarTodos = false;
    } else {
      // Verifica se todos foram marcados individualmente
      let todosMarcados = true;
      for (let l of this.laudos) {
        if (!this.selecionados[l.id_laudo]) {
          todosMarcados = false;
          break;
        }
      }
      this.selecionarTodos = todosMarcados;
    }
  }

  getSelecionadosIds(): string[] {
    let ids = [];
    for (let id in this.selecionados) {
      if (this.selecionados[id]) {
        ids.push(id);
      }
    }
    return ids;
  }

  executarAcaoEmMassa(acao: string, extraParam: any = null) {
    let selecionadosIds = this.getSelecionadosIds();
    if (selecionadosIds.length == 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaExecutarAcaoMassa'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    }, function () {
      self.carregandoAcoesEmMassa = true;
      let total = selecionadosIds.length;
      let concluidos = 0;

      let finalizarSeConcluido = () => {
        if (concluidos == total) {
          self.carregandoAcoesEmMassa = false;
          swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.acaoConcluida'), "success");
          self.getPage(self.paginaAtual);
          self.selecionados = {};
          self.selecionarTodos = false;
        }
      };

      selecionadosIds.forEach(id => {
        let item = self.laudos.find(l => l.id_laudo == <any>id);

        // Se for alteração de status e o item já estiver Online (2), ignora
        if (acao == 'status' && item && item.id_status == 2) {
          concluidos++;
          finalizarSeConcluido();
          return;
        }

        self.processandoItem[id] = true;

        let obs;
        if (acao == 'deletar') obs = self.laudosService.apagar(id);
        if (acao == 'notificar') obs = self.laudosService.enviarLaudoParaCliente(id);
        if (acao == 'status') obs = self.laudosService.setStatus(id, extraParam.id_status, extraParam.notifica);

        obs.subscribe(
          res => {
            delete self.processandoItem[id];
            concluidos++;
            finalizarSeConcluido();
          },
          err => {
            delete self.processandoItem[id];
            concluidos++;
            self.func.showErro(err.json());
            if (concluidos == total) {
              self.carregandoAcoesEmMassa = false;
              self.getPage(self.paginaAtual);
            }
          }
        );
      });
    });
  }

  abrirModalEnviarEmail(id) {
    this.idLaudoParaEnviarEmail = id;
    this.emailDestinatario = '';
    this.enviandoEmail = false;
    $('#modalEnviarEmail').modal('show');
  }

  enviarEmail() {
    if (!this.emailDestinatario || !this.func.validaEmail(this.emailDestinatario)) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.emailInvalido'), "error");
      return;
    }

    this.enviandoEmail = true;
    this.laudosService.enviarLaudoParaEmailEspecifico(this.idLaudoParaEnviarEmail, this.emailDestinatario)
      .subscribe(
        res => {
          this.enviandoEmail = false;
          $('#modalEnviarEmail').modal('hide');
          swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.emailEnviadoSucesso'), "success");
        },
        err => {
          this.enviandoEmail = false;
          this.func.showErro(err.json());
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/laudos-pdf/laudos-pdf.component.ts